export default __webpack_public_path__ + "static/media/singleRight.11d54274.wav";